// withImages.ts
import { Editor } from "slate";

/**
 * 이미지 노드를 Void Node로 인식시키는 플러그인
 */
export function withImages<T extends Editor>(editor: T): T {
  const { isVoid } = editor;

  // isVoid를 오버라이드하여, type === 'image' 인 노드는 Void Node로 처리
  editor.isVoid = (element) => {
    if (element.type === "image") {
      return true;
    }
    return isVoid(element);
  };

  return editor;
}
